import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-br from-[#2D2A3E] via-[#3A2F4A] to-[#2D2A3E] px-4 text-center relative overflow-hidden" data-id="element-63">
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#C4973B]/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-64"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C06B6B]/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-65"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#B8A9C9]/5 rounded-full blur-3xl" data-id="element-66"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-67">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8" data-id="element-68">
          Tu mente merece descansar
        </h2>

        <div className="space-y-4 mb-12 text-white/90 text-lg" data-id="element-69">
          <p className="font-bold text-white text-xl" data-id="element-70">
            Empieza hoy mismo a sentir más tranquilidad, claridad mental y paz
            emocional.
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-[#C4973B]/20 shadow-2xl" data-id="element-71">
          {/* Price reminder */}
          <div className="mb-8" data-id="element-72">
            <p className="text-white/40 text-sm line-through mb-1" data-id="element-73">
              Valor Total: $75
            </p>
            <p className="text-white font-bold text-2xl" data-id="element-74">
              Hoy: $11.99 · Pago único
            </p>
            <p className="text-sm text-[#C4973B] font-semibold mt-1" data-id="element-75">
              Ahorras $63 hoy (84% descuento)
            </p>
            <p className="text-white/50 text-sm mt-1" data-id="element-76">
              📲 Acceso inmediato · Formato PDF descargable
            </p>
          </div>

          <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-gradient-to-r from-[#C4973B] to-[#D4A84C] text-white font-bold text-xl py-5 px-10 rounded-full shadow-xl shadow-[#C4973B]/30 hover:shadow-2xl hover:shadow-[#C4973B]/40 hover:scale-105 transition-all flex items-center justify-center gap-3 mx-auto group" data-id="element-77">
            👉 DESCARGAR MI EBOOK AHORA
            <ArrowRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-78" />
          </a>

          <p className="mt-6 text-sm text-white/40" data-id="element-79">
            $11.99 · Acceso inmediato · Garantía incluida
          </p>
        </div>
      </div>
    </section>;
}